export default __webpack_public_path__ + "static/media/0x8063037ea50e4a066bf1430ea1e3e609cd5cef6b.431b9c21.webp";